import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Select, RNLLoader, HeaderBack } from '../components/UI';
import BOQFormPage from './BOQFormPage';
import * as api from '../api';

export default function BOQEntryPage({ toast }) {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState('');
  const [loadingInitial, setLoadingInitial] = useState(true);

  useEffect(() => {
    const loadInitial = async () => {
      try {
        const projRes = await api.listProjects();
        setProjects(Array.isArray(projRes) ? projRes : (projRes?.data || projRes?.items || []));
      } catch (e) {
        toast?.show?.('Failed to load projects', 'error');
      } finally {
        setLoadingInitial(false);
      }
    };
    loadInitial();
  }, [toast]);

  if (loadingInitial) {
    return <RNLLoader title="Loading Master Data..." subtitle="Please wait" />;
  }

  const selectedProject = projects.find(p => p.project_id === selectedProjectId || p.id === selectedProjectId);

  return (
    <div className="fade-in" style={{ padding: '10px 0', maxWidth: '100%', margin: '0 auto', width: '100%' }}>
      {/* Back button moved to top header */}
      <HeaderBack onClick={() => navigate('/report-entry')} label="Back to Report Entry" />

      <div style={{ background: '#ffffff', border: '3px solid black', borderRadius: 22, padding: 18, boxShadow: 'var(--shadow-lg)' }}>
        <div style={{ borderRadius: 12, overflow: 'hidden', background: '#ffffff', border: '1px solid black' }}>
          {/* PROJECT SELECTION BAR & TITLE */}
          <div style={{ background: '#0b318bff', padding: '18px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <h2 style={{ margin: 0, fontSize: 19, fontWeight: 800, color: '#ffffff', letterSpacing: '0.02em' }}>
              New BOQ Form
            </h2>

            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
              <div style={{ color: '#fff', fontSize: 14, fontWeight: 800, whiteSpace: 'nowrap' }}>SELECT PROJECT:</div>
              <div style={{ width: 280 }}>
                <Select
                  value={selectedProjectId}
                  onChange={setSelectedProjectId}
                  options={[{ value: '', label: '— Select Project Context —' }, ...projects.map(p => ({ value: p.project_id || p.id, label: p.project_name }))]}
                  style={{ background: '#fff', border: 'none', borderRadius: 8, height: 38 }}
                />
              </div>
            </div>
          </div>

          {!selectedProjectId ? (
            <div style={{ padding: 60, textAlign: 'center', color: 'var(--text-muted)' }}>
              <div style={{ fontSize: 40, marginBottom: 16 }}>🏢</div>
              <h3 style={{ fontSize: 18, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 8 }}>No Project Selected</h3>
              <p>Please select a project from the dropdown above to continue with the entry.</p>
            </div>
          ) : (
            <BOQFormPage
              project={selectedProject}
              onBack={() => navigate('/report-entry')}
              hideBackButton={true}
            />
          )}
        </div>
      </div>
    </div>
  );
}
